import { useState } from "react";
import { Link } from "react-router-dom";

const Faq = () => {
  const faqs = [
    {
      question: "What is Sunday School?",
      answer:
        "Sunday School is a Christ-centered learning environment where children, youth, and adults grow in their understanding of the Bible and strengthen their faith through teaching, fellowship, and worship.",
    },
    {
      question: "Who can join Sunday School?",
      answer:
        "Sunday School is open to everyone — children, teens, and adults — who desire to learn more about God’s Word and build a strong spiritual foundation.",
    },
    {
      question: "How are lessons structured?",
      answer:
        "Each lesson is grounded in Scripture and presented in an engaging way through storytelling, interactive activities, and discussions led by dedicated teachers.",
    },
    {
      question: "Do parents have a role in Sunday School?",
      answer:
        "Yes! Parents are encouraged to stay involved in their child’s spiritual journey through shared devotion time, lesson updates, and family faith activities.",
    },
    {
      question: "Are the classes held online or in person?",
      answer:
        "Currently, classes are conducted in person at the church. Online access may be added in the future as part of our digital ministry expansion.",
    },
    {
      question: "Who teaches the Sunday School classes?",
      answer:
        "Classes are led by trained and committed teachers who are passionate about sharing the love of Christ and guiding students in their walk of faith.",
    },
    {
      question: "What makes your Sunday School different?",
      answer:
        "Our Sunday School focuses on faith, family, and fellowship — creating a nurturing environment where students not only learn but also live out their faith through worship and community engagement.",
    },
    {
      question: "Is there any cost to join Sunday School?",
      answer:
        "No, Sunday School is completely free to join. Our goal is to make God’s Word accessible to everyone, regardless of background or circumstance.",
    },
    {
      question: "How can I register or get involved?",
      answer:
        "You can sign up at the church welcome desk or through our contact page. We also welcome volunteers who wish to serve as teachers or contributors.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="bg-gradient-to-br from-gray-50 to-blue-50 min-h-screen">
      <section className="bg-primary text-white text-center py-20 px-6">
        <h1 className="text-5xl md:text-6xl font-extrabold mb-4">❓ Frequently Asked Questions</h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto">
          Have questions? We've got answers. Explore our FAQ section to learn more about our platform and courses.
        </p>
      </section>

      <section className="py-16 px-6 max-w-4xl mx-auto">
        <h2 className="text-4xl font-bold text-gray-800 text-center mb-12">Common Questions</h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full text-left px-6 py-4 flex justify-between items-center text-lg font-semibold text-gray-800 hover:bg-gray-100 transition"
              >
                <span>{faq.question}</span>
                <span className="text-primary font-bold text-2xl">
                  {activeIndex === index ? "-" : "+"}
                </span>
              </button>
              {activeIndex === index && (
                <div className="px-6 py-4 border-t text-gray-700 text-sm">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 px-6 text-center">
        <h2 className="text-4xl font-bold text-gray-800 mb-4">Still have questions?</h2>
        <p className="text-gray-600 max-w-2xl mx-auto mb-8">
          Reach out to our support team and we'll help you with any queries or issues you may have.
        </p>
        <Link to="/contact-us">
          <button className="bg-primary text-white font-semibold px-8 py-4 rounded-full hover:bg-blue-600 transition">
            Contact Support
          </button>
        </Link>
      </section>
    </div>
  );
};

export default Faq;